
import { BaseDto } from '@/shared/dtos/base-dto';

export class ejercicio_notas extends BaseDto {
    public id_paciente !: number;
    public id_ejercicio !: number;
    public nota !: string;
} 
